export const DEFAULT_FINAL_STEP_TEXT = {
  title: 'Pelo que você respondeu, há um caminho claro a seguir.',
  description:
    'Posso te dar uma orientação personalizada em poucos minutos, incluindo o que fazer agora e quais documentos você vai precisar.',
  ctaLabel: 'Continuar',
} as const

export const DEFAULT_WHATSAPP_MESSAGE =
  'Olá! Acabei de ler um artigo no Jusbrasil e gostaria de orientação sobre meus direitos.'
